<template>
  <section v-loading="busy" class="shared-settings">
    <p class="notice">全站共用设定适用于所有站点。修改后，所有<strong>未自订</strong>该项目的站点立即套用（新会话生效）；已自订的站点保留自己的设定，也可以在本站取消自订改回共用值。平台App 等站点专属软件不在此处。</p>
    <p v-if="error" role="alert" class="error">{{ error }}</p>
    <p v-if="loaded && !initialized" class="notice">全站共用设定尚未启用。部署新版后台后会自动以 LHCS 目前的设定启用。</p>
    <template v-if="initialized">
      <section class="setting-card">
        <h3>共用官网地址</h3>
        <p class="setting-help">回复中的 <code v-pre>{{siteUrl.url}}</code> 在未自订的站点使用此地址。</p>
        <input v-model="websiteUrl" aria-label="共用官网地址" class="website-input" placeholder="https://www.example.com" :readonly="!canEdit" :disabled="busy">
        <div class="setting-footer"><span>{{ canEdit ? '保存后影响所有未自订官网地址的站点。' : '当前为只读，共用设定由管理员维护。' }}</span><el-button v-if="canEdit" type="primary" :disabled="busy || websiteUrl === savedWebsiteUrl" @click="saveWebsite">保存共用官网地址</el-button></div>
      </section>
      <section class="setting-card">
        <h3>共用软件下载目录</h3>
        <p class="setting-help">AMICO、各钱包等外部软件的名称、别名、下载地址。未自订的站点使用这里的设定。</p>
        <AiBusinessDirectory ref="directory" :site="site" :can-edit="canEdit" shared />
      </section>
    </template>
  </section>
</template>
<script setup>
/* global defineProps, defineExpose */
import { computed, onMounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { siteContentRequest } from '@/api/ai-workflows'
import AiBusinessDirectory from './AiBusinessDirectory.vue'
const props = defineProps({ site: { type: Object, required: true }, canEdit: Boolean })
const busy = ref(false); const error = ref(''); const loaded = ref(false); const initialized = ref(false); const revision = ref(0)
const websiteUrl = ref(''); const savedWebsiteUrl = ref(''); const directory = ref(null)
const request = (method, suffix, data) => siteContentRequest(props.site.id, method, `/shared${suffix}`, data)
function accept(data) { initialized.value = !!data.initialized; revision.value = data.revision; websiteUrl.value = savedWebsiteUrl.value = data.websiteUrl || ''; loaded.value = true }
async function run(fn) { if (busy.value) return; busy.value = true; error.value = ''; try { await fn() } catch (e) { error.value = e.response?.data?.message || e.message } finally { busy.value = false } }
async function saveWebsite() {
  if (!props.canEdit) return
  try { await ElMessageBox.confirm('共用官网地址会影响所有未自订的站点，确定保存？', '修改全站共用设定') } catch { return }
  await run(async () => { accept(await request('PUT', '/website', { expectedRevision: revision.value, url: websiteUrl.value.trim() })); ElMessage.success('共用官网地址已保存') })
}
const dirty = computed(() => websiteUrl.value !== savedWebsiteUrl.value || !!directory.value?.dirty)
async function discard() {
  if (directory.value && !await directory.value.discard()) return false
  if (websiteUrl.value !== savedWebsiteUrl.value) { try { await ElMessageBox.confirm('共用官网地址有未保存修改，确定放弃？', '切换内容') } catch { return false } websiteUrl.value = savedWebsiteUrl.value }
  return true
}
defineExpose({ discard, dirty, busy })
onMounted(() => run(async () => accept(await request('GET', ''))))
</script>
<style scoped>
.shared-settings { color:#334155; }
.notice { padding:12px 14px; background:#f8fafc; border:1px solid #e2e8f0; border-radius:8px; font-size:13px; line-height:1.7; color:#475569; }
.error { padding:10px 12px; background:#fff0f0; color:#ad2432; border-radius:6px; }
.setting-card { margin:16px 0; padding:16px; border:1px solid #e4eaf2; border-radius:10px; background:white; }
.setting-card h3 { margin:0 0 6px; font-size:16px; }
.setting-help { color:#64748b; font-size:13px; }
.website-input { display:block; width:100%; max-width:560px; box-sizing:border-box; margin:8px 0; padding:8px 10px; border:1px solid #cbd5e1; border-radius:6px; }
.setting-footer { display:flex; justify-content:space-between; align-items:center; gap:12px; flex-wrap:wrap; font-size:12px; color:#64748b; }
</style>
